import {
   HealthcareProviderLocation,
   HealthcareProviderLocationQuery,
} from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { CqrsQueryPerformResult, performCqrsQuerySearch } from '@dreryk/command-query-react-common';

export const healthcareLocationSearchCreator = () => {
   return async (): CqrsQueryPerformResult<HealthcareProviderLocation[]> =>
      performCqrsQuerySearch<HealthcareProviderLocation>(() => {
         return new HealthcareProviderLocationQuery();
      });
};
